export default __webpack_public_path__ + "static/media/plain-sticker-us.e6c5410b.png";